import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { SearchModel, SearchResultModel } from 'src/common/components';
import { ActiveEmployeeModel, ActiveUserModel, LoginModel } from './user.model';

@Injectable()
export class UsersService {

    constructor(private http: HttpClient) { }

    searchActiveUsers(search: SearchModel): Promise<SearchResultModel<ActiveUserModel>> {
        return this.http.post<SearchResultModel<ActiveUserModel>>(`${environment.apiUrl}/users/searchActiveUsers`, search).toPromise();
    }

    searchActiveEmployees(search: SearchModel): Promise<SearchResultModel<ActiveEmployeeModel>> {
        return this.http.post<SearchResultModel<ActiveEmployeeModel>>(`${environment.apiUrl}/users/searchActiveEmployees`, search).toPromise();
    }

    searchActiveEmployeesOpnBoardMembersList(search: SearchModel,id:number): Promise<SearchResultModel<ActiveEmployeeModel>> {
      return this.http.post<SearchResultModel<ActiveEmployeeModel>>(`${environment.apiUrl}/users/searchActiveEmployeesOpnBoardMembersList/${id}`, search).
            toPromise();
  }

    loginUser(model: LoginModel): Promise<void> {
        return this.http.post<void>(`${environment.apiUrl}/users/loginUser`, model).toPromise();
    }
}
